import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { updateLoader } from '../../_redux/LoaderSlice';
import { updateSnackbar } from '../../_redux/SnackbarSlice';
import { getAccessToken } from '../../_utilities/utilities';
import { sessionExpired } from '../_apiHelpers/_apihelper';

const initialState = { data: [], error: null };

export const getInvoicesSlice = createSlice({
  name: 'GetInvoices',
  initialState,
  reducers: {
    getInvoicesStart: (state) => ({ ...state, error: null }),
    getInvoicesSuccess: (state, action) => ({
      ...state,
      data: action.payload,
      error: null,
    }),
    getInvoicesFailure: (state, action) => ({
      ...state,
      error: action.payload,
      data: [],
    }),
  },
});

export const { getInvoicesStart, getInvoicesSuccess, getInvoicesFailure } =
  getInvoicesSlice.actions;

export const getInvoicesAsync = (customerId) => async (dispatch) => {
  try {
    dispatch(updateLoader(true));
    dispatch(getInvoicesStart());
    const baseUrl = process.env.REACT_APP_INVOICE_API_BASE;
    const { data } = await axios.get(`${baseUrl}?customer_id=${customerId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });
    dispatch(getInvoicesSuccess(Array.isArray(data) ? data : []));
  } catch (error) {
    if (error?.response?.status === 405 || error?.response?.status === 406) {
      return sessionExpired(error?.response?.data?.message);
    }
    dispatch(getInvoicesFailure(error?.message || 'Failed to fetch invoices'));
    dispatch(
      updateSnackbar({
        type: 'error',
        message: 'Failed to fetch invoices. Please try again later.',
      })
    );
  } finally {
    dispatch(updateLoader(false));
  }
};
